import keyMirror from 'keymirror'

export default keyMirror({
  GET_ROLES_CONFIGURATION_REQUEST: null,
  GET_ROLES_CONFIGURATION_SUCCESS: null,
  GET_ROLES_CONFIGURATION_FAILED: null,

  UPDATE_ROLES_CONFIGURATION_REQUEST: null,
  UPDATE_ROLES_CONFIGURATION_SUCCESS: null,
  UPDATE_ROLES_CONFIGURATION_FAILED: null,

  GET_ALLOWED_ROLE_MANAGE_REQUEST: null,
  GET_ALLOWED_ROLE_MANAGE_SUCCESS: null,
  GET_ALLOWED_ROLE_MANAGE_FAILED: null,

  UPDATE_ALLOWED_ROLE_MANAGE_REQUEST: null,
  UPDATE_ALLOWED_ROLE_MANAGE_SUCCESS: null,
  UPDATE_ALLOWED_ROLE_MANAGE_FAILED: null
})
